module.exports = __webpack_public_path__ + "static/media/pickup.385f98d9.svg";